var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLeftArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 6.16,
  height: 11.555,
  viewBox: "7.04 4.306 6.16 11.555"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  "data-name": "Path 280330"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.91 4.666a.352.352 0 0 0-.51 0 .352.352 0 0 0 0 .51l5.176 5.14L7.4 15.492a.352.352 0 0 0 0 .51.33.33 0 0 0 .255.11.33.33 0 0 0 .255-.11l5.431-5.395a.33.33 0 0 0 .11-.255.33.33 0 0 0-.11-.255L7.91 4.666Z",
  fillRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.91 4.666a.352.352 0 0 0-.51 0 .352.352 0 0 0 0 .51l5.176 5.14L7.4 15.492a.352.352 0 0 0 0 .51.33.33 0 0 0 .255.11.33.33 0 0 0 .255-.11l5.431-5.395a.33.33 0 0 0 .11-.255.33.33 0 0 0-.11-.255L7.91 4.666Z",
  strokeLinejoin: "round",
  strokeLinecap: "round",
  strokeWidth: 0.5,
  stroke: "#000",
  fill: "transparent"
}))));
export default SvgLeftArrow;